import { z } from "zod";
export const ADMIN_SEARCH_TYPES = [
    "announcement",
    "promotion",
    "sponsored",
    "site",
    "site_group",
    "reseller",
];
export const adminSearchQuerySchema = z.object({
    q: z.string().max(120).optional().default(""),
    limit: z.coerce.number().int().min(1).max(8).optional().default(8),
});
export const adminSearchHitSchema = z.object({
    type: z.enum(ADMIN_SEARCH_TYPES),
    id: z.string(),
    title: z.string(),
    href: z.string(),
    state: z.string().optional(),
});
export const adminSearchResponseSchema = z.object({
    items: z.array(adminSearchHitSchema),
});
//# sourceMappingURL=admin-search.js.map